
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.338 3.566L3.776 14.13a2.95 2.95 0 00.437 4.1l7.963 7.962a2.95 2.95 0 004.1.438l10.562-10.563c.481-.494.72-1.176.65-1.862l-.55-7.5a3.625 3.625 0 00-3.237-3.238l-7.5-.55a2.338 2.338 0 00-1.863.65zm6.063 8.224c-.473 0-.924-.194-1.25-.536a1.725 1.725 0 010-2.5 1.768 1.768 0 012.5 2.5 1.725 1.725 0 01-1.25.536z","fill":"#7B01B5"}})])
          )
        }
      }
    